'use client';

import * as TooltipPrimitive from '@radix-ui/react-tooltip';
import React from 'react';

export const TooltipProvider = TooltipPrimitive.Provider;
export const TooltipRoot = TooltipPrimitive.Root;
export const TooltipTrigger = TooltipPrimitive.Trigger;
export const TooltipArrow = TooltipPrimitive.Arrow;

export const TooltipContent = React.forwardRef<
	React.ElementRef<typeof TooltipPrimitive.Content>,
	React.ComponentPropsWithoutRef<typeof TooltipPrimitive.Content>
>(({ children, ...props }, forwardedRef) => (
	<TooltipPrimitive.Portal>
		<TooltipPrimitive.Content ref={forwardedRef} onClick={(e) => e.stopPropagation()} {...props}>
			{children}
		</TooltipPrimitive.Content>
	</TooltipPrimitive.Portal>
));
TooltipContent.displayName = TooltipPrimitive.Content.displayName;
